import React, { Fragment } from "react"
import classnames from "classnames"
import { Link } from "react-router-dom"
import PropTypes from "prop-types"

import SpinnerLoad from "../SpinnerLoad"

import styles from "./styles.css"

const ButtonFixedVoice = ({
  isOutline,
  isSecondary,
  isRight,
  isDisabled,
  icon,
  name,
  linkName,
  onAction,
  isLoading,
  className,
  hasBackgroundLink
}) => {
  const buttonClass = classnames(
    styles.defaultClass,
    {
      [styles.primary]: !isOutline && !isSecondary,
      [styles.secondaryOutline]: isOutline,
      [styles.secondary]: isSecondary
    },
    className
  )

  const linkClass = classnames(
    styles.secondaryOutline,
    styles.defaultClass,
    {
      [styles.disabledLink]: isDisabled,
      [styles.linkBackground]: hasBackgroundLink
    },
    className
  )

  return (
    <div>
      {isRight && (
        <button className={buttonClass} onClick={onAction}>
          <div className={styles.div_flex}>
            <span>{name}</span>
            <div className={styles.icon_right}>
              <img src={icon} alt={"icon"} />
            </div>
          </div>
        </button>
      )}

      {!isRight && (
        <Fragment>
          {onAction && (
            <button
              disabled={isDisabled}
              type={"submit"}
              className={buttonClass}
              onClick={onAction}
            >
              {isLoading ? <SpinnerLoad isButton /> : name}
            </button>
          )}

          {!onAction && (
            <Link className={linkClass} to={`/fixed-voice/${linkName}`}>
              {icon && (
                <div className={styles.icon}>
                  <img src={icon} alt={"icon"} />
                </div>
              )}
              <span>{name}</span>
            </Link>
          )}
        </Fragment>
      )}
    </div>
  )
}

ButtonFixedVoice.propTypes = {
  isOutline: PropTypes.bool,
  isSecondary: PropTypes.bool,
  isRight: PropTypes.bool,
  isDisabled: PropTypes.bool,
  icon: PropTypes.string,
  name: PropTypes.string,
  linkName: PropTypes.string,
  onAction: PropTypes.func,
  isLoading: PropTypes.bool,
  className: PropTypes.string,
  hasBackgroundLink: PropTypes.string
}

export default ButtonFixedVoice



// WEBPACK FOOTER //
// ./src/scenes/FixedVoice/components/ButtonFixedVoice/index.js